import { render, staticRenderFns } from "./ajout-temoignage.vue?vue&type=template&id=67684fac"
import script from "./ajout-temoignage.vue?vue&type=script&lang=js"
export * from "./ajout-temoignage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports